import { Navigate } from "react-router-dom";
import { useAuthState } from "./context";

export const isAdmin = user => user?.isAdmin === true;
// Taquilla: solo control de acceso. La administración también puede usarlo.
export const canDoor = user => isAdmin(user) || user?.isTaquilla === true;

export default function PrivateRoute({ children, taquilla = false }) {
  const userDetails = useAuthState(); //read user details from context
  const user = userDetails.token ? userDetails.user : null;
  if (taquilla ? canDoor(user) : isAdmin(user)) return children;
  return <Navigate to={canDoor(user) ? "/taquilla" : "/login"} replace />;
}
